import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import type { ComponentType } from 'react';

import { useUiStore } from '../store/useUiStore';
import type { LayoutType } from '../../shared/types/LayoutType';

type AppRouteProps = {
  component: ComponentType;
  routeKey: string;
  layout?: LayoutType;
};

const AppRoute = ({ component: Component, routeKey, layout: routeLayout }: AppRouteProps) => {
  const location = useLocation();
  const layout = useUiStore((state) => state.layout);
  const setLayout = useUiStore((state) => state.setLayout);
  const setPreviousLayout = useUiStore((state) => state.setPreviousLayout);

  useLayoutEffect(() => {
    if (routeLayout && routeLayout !== layout.type) {
      setPreviousLayout(layout.type);
      setLayout(routeLayout);
      return;
    }

    if (!routeLayout && layout.previousType && layout.type !== layout.previousType) {
      setLayout(layout.previousType);
      setPreviousLayout('');
    }
  }, [
    location.pathname,
    routeLayout,
    layout.type,
    layout.previousType,
    setLayout,
    setPreviousLayout,
  ]);
  
  return <Component />;
};

export default AppRoute;